import { styled, Typography } from '@mui/material';

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginRight: theme.spacing(),

  [theme.breakpoints.up('lg')]: {
    fontSize: '14px',
  },
}));
